import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';

export class VrboSearchController implements Controller {
  public pageId = 'VrboSearchWidget';
  public path = '/:localeName/vrbo-search';
  public routeName = 'vrbosearch';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/vrbo-search-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData() {
    return Promise.resolve({ title: 'Vrbo Search Widget' }) as Promise<PageData>;
  }
}
